import { ReactNode, useEffect, useState } from "react";
import { CustomInput } from "./Ui/CustomInput";
import enquiryscss from "../../sass/enquiry-list/Enquiry.module.scss";

type IPaxInfo = {
  adult: number;
  child: number;
  infant: number;
};

const paxArray = ["adult", "child", "infant"];

export const AdultChildDetails: React.FC<{
  label: string;
  paxInfo: IPaxInfo;
  show: boolean;
  onOpen: () => void;
  onClose: () => void;
  onSave: (paxInfo: IPaxInfo) => void;
  reset?: boolean;
  afterReset?: () => void;
  children?: ReactNode;
}> = (props) => {
  const [paxInfo, setPaxInfo] = useState<IPaxInfo>({ ...props.paxInfo });

  useEffect(() => {
    /**
     * Original code: setPaxInfo(props.paxInfo);
     * but due to the following issue, we have to use the following code:
     * issue: reset the data whenever the props.children state changes (e.g. in hotel component when the user changes room count)
     */
    if (!props.children || props.reset) {
      setPaxInfo({ ...props.paxInfo });
      if (props.reset && props.afterReset) {
        props.afterReset();
      }
    }
  }, [props.paxInfo]);

  return (
    <div className={enquiryscss.passengerBtn}>
      <label className=" mb-0">{props.label}</label>
      <button
        className="btn bg-white w-100 text-start"
        onClick={props.onOpen}
        type="button"
      >
        <span className="text-secondary flight-passenger-info">
          <i className="fas fa-user input-icon pe-2"></i>
          {props.paxInfo.adult} Ad, {props.paxInfo.child} Ch,{" "}
          {props.paxInfo.infant} In
        </span>
      </button>
      {props.show && (
        <div className="form-popup p-3" id="passenger">
          <div className="row">
            {paxArray.map((paxType) => {
              return (
                <div key={paxType} className="col-lg-4 col-md-4 col-sm-4 col-4">
                  <CustomInput
                    label={paxType.toUpperCase()}
                    labelClassname="text-secondary"
                    type="number"
                    id={paxType}
                    placeholder={paxType === "adult" ? "1" : "0"}
                    className={`py-2 ${
                      paxInfo[paxType] === undefined ||
                      (paxType === "adult" && paxInfo[paxType] < 1)
                        ? "border-danger"
                        : ""
                    }`}
                    min={paxType === "adult" ? 1 : 0}
                    value={
                      paxInfo[paxType] === undefined ? "" : paxInfo[paxType]
                    }
                    required={paxType === "adult"}
                    onChange={(e) => {
                      const value = e.target.value
                        ? parseInt(e.target.value)
                        : undefined;
                      setPaxInfo((old) => {
                        old[paxType] = value;
                        return { ...old };
                      });
                    }}
                  />
                </div>
              );
            })}
          </div>
          {props.children}
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
              <button
                type="button"
                onClick={() => {
                  if (
                    !paxInfo.adult ||
                    paxInfo.child === undefined ||
                    paxInfo.infant === undefined
                  ) {
                    return;
                  }
                  props.onSave(paxInfo);
                }}
                className="btn submit-passenger-class w-100"
              >
                Submit
              </button>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
              <button
                type="button"
                onClick={() => {
                  props.onClose();
                  setPaxInfo(props.paxInfo);
                }}
                className="btn cancel w-100"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
